<template>
  <div class="home">


    <div class="row justify-content-center">
      <div class="col-sm-4">
        <div class="card h-100">
          <div class="card-body">
            Con la seguente procedura hai la possibilità di registrare il tuo prodotto.
          </div>
          <div class="card-footer">
            <router-link to="/insert" class="btn btn-lg btn-primary w-100">Registrazione garanzia</router-link>
          </div>
        </div>
        
      </div>
      <div class="col-sm-4">

        <div class="card h-100">
          <div class="card-body">
            Verifica se la garanzia del tuo prodotto è stata correttamente registrata.
          </div>
          <div class="card-footer">
            <router-link to="/check" class="btn btn-lg btn-primary w-100">Archivio garanzia</router-link>
          </div>
        </div>


        
      </div>
    </div>

    
    
  </div>
</template>

<script>
// @ is an alias to /src

import CmMixin from '../../../webapp/src/mixins/CmMixin'
// import CmMixin from '../mixins/CmMixin'

export default {
  mixins: [ CmMixin ],
  name: 'Home',
  data: () => {
		return {
      
			
		}
	},
  mounted: function(){
    
  },
  methods:{
    
  },
  computed:{
    
  }
  
}
</script>
